var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cms-accordion-block", style: _vm.containerStyle },
    _vm._l(_vm.parsedItems, function (item, idx) {
      return _c(
        "div",
        {
          key: idx,
          staticClass: "cms-accordion-block__item",
          class: {
            "cms-accordion-block__item--open": _vm.isOpen(idx),
            "cms-accordion-block__item--after-open":
              idx > 0 && _vm.isOpen(idx - 1),
          },
          style: _vm.itemStyle,
        },
        [
          _c(
            "button",
            {
              staticClass: "cms-accordion-block__trigger",
              style: _vm.triggerStyle,
              attrs: { "aria-expanded": _vm.isOpen(idx) ? "true" : "false" },
              on: {
                click: function ($event) {
                  return _vm.toggle(idx)
                },
              },
            },
            [
              _c("span", { staticClass: "cms-accordion-block__question" }, [
                _vm._v(_vm._s(item.question)),
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa cms-accordion-block__chevron",
                class: _vm.isOpen(idx) ? "fa-chevron-up" : "fa-chevron-down",
                style: _vm.isOpen(idx) ? { color: _vm.accentColor } : {},
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cms-accordion-block__body",
              class: { "cms-accordion-block__body--open": _vm.isOpen(idx) },
              style: _vm.bodyStyle,
            },
            [
              _c("div", {
                staticClass: "cms-accordion-block__answer",
                domProps: { innerHTML: _vm._s(_vm.sanitized(item.answer)) },
              }),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }